var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPnClove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 66,
    viewBox: "0 0 60 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.922238 60C0.943905 60 0.965189 60 0.986477 60C2.69061 59.8821 42.8321 57.1047 52.8513 46.0697C57.793 40.6217 60.3209 33.5652 59.9674 26.2191C59.6138 18.8624 56.4207 12.0954 50.9761 7.14092C39.7352 -3.06848 22.2792 -2.232 12.0776 9.01764C2.09039 20.0206 0.0756799 57.4371 0.000793881 59.0243C-0.00984981 59.2923 0.086716 59.5498 0.279443 59.7429C0.440239 59.9038 0.675912 60 0.922238 60Z",
    fill: "#FFB531"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53779 66.0005C6.55513 66.0006 6.57216 66.0006 6.58919 66.0006C7.95256 65.9073 40.0674 63.7094 48.0894 54.8874C52.046 50.532 54.0725 44.8883 53.7941 39.0112C53.5157 33.1256 50.9653 27.7101 46.6125 23.7433C37.6259 15.569 23.6606 16.2277 15.4926 25.2213C7.49626 34.0177 5.86208 63.9497 5.80122 65.2194C5.79255 65.4339 5.86965 65.6399 6.02371 65.7945C6.15225 65.9233 6.34073 66.0004 6.53779 66.0005Z",
    fill: "#442873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnClove);
export default __webpack_public_path__ + "static/media/pn_clove.9c05bd4cde17fd6b2739ad83dc32305c.svg";
export { ForwardRef as ReactComponent };